import type { ButtonProps } from "antd";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

const InfoButton = (buttonProps: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="informationButton"
      icon={<InfoCircleOutlined />}
      role="button"
      type="default"
      {...buttonProps}
    >
      {t("global:info")}
    </Button>
  );
};

export default InfoButton;
